import React, { FC, useEffect, useContext } from 'react';
import { DecisionPopover } from '../../popover/DecisionPopover';
import {
  WithRestrictedModalProps,
  withRestrictedModal,
} from '../../../components/modal/components/modal-restricted/withRestrictedModal';
import { UserContext } from '../../../user/UserContext';
import { doctrineAnalytics } from '../../../utils/analyticsUtils';
import { buildUrlWithParameters } from '../../../utils/url-utils/urlUtils';

type Props = {
  decision: {
    url: string;
    title: string;
    sommaireAnaHtml?: string;
  };
  source: string;
} & WithRestrictedModalProps;

export const RawLegislationSnippetDecisionPopover: FC<Props> = ({
  source,
  decision,
  openRestrictedModal,
}) => {
  const { accessPremium } = useContext(UserContext);
  useEffect(() => {
    doctrineAnalytics('Search DisplayDecisionPopover');
  }, []);

  const handleClick = () => {
    doctrineAnalytics('Search DecisionPopoverClicked');
    if (!accessPremium) {
      openRestrictedModal('decision_popover');
    }
  };

  return (
    <DecisionPopover
      title={decision.title}
      summary={decision.sommaireAnaHtml}
      handleClick={handleClick}
      href={
        accessPremium
          ? buildUrlWithParameters(decision.url, {
              source,
            })
          : undefined
      }
    />
  );
};

export const LegislationSnippetDecisionPopover = withRestrictedModal(
  RawLegislationSnippetDecisionPopover,
);
